export default __webpack_public_path__ + "static/calendar-fdbba39c4bf7cc349226055d60274bde.jpg";